<div class="transcript-distribution" c-toggle="showView" c-toggle-options="{type: 'fade'}">
    <div c-transcript-distribution="transcript" class="child"></div>
</div>